import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import upgradeAnimation from "../../dataFiles/animation/upgrade.json";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import { ReactComponent as PlanImg1 } from "../AI-Writer/Assets/plan-1.svg";
import { ReactComponent as PlanImg2 } from "../AI-Writer/Assets/plan-2.svg";
import { ReactComponent as PlanImg3 } from "../AI-Writer/Assets/plan-3.svg";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AIOverviewIcon from "../../../admin/assets/sidebar/ai black.png";
import "../../css/ai-writer.scss";

const PlUpgrade = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isAIOTracker = pathname === "/ai-tracker";
  const email = localStorage.getItem("admin_mail");

  const gotologin = () => {
    navigate("/upgrade");
  };

  const plan = [
    {
      plan_name: "Starter",
      amt: "$12",
      img: <PlanImg1 className="plan-img" />,
      feature: ["100 AIO Keywords", "Daily Tracking"],
      plan_link: `https://buy.stripe.com/6oUeVdgf0e2E95X5Vv0Fi1c?prefilled_email=${email}`,
    },
    {
      plan_name: "Growth",
      amt: "$19",
      img: <PlanImg2 className="plan-img" />,
      feature: ["200 AIO Keywords", "Daily Tracking"],
      plan_link: `https://buy.stripe.com/9B6dR92oacYAdmd4Rr0Fi1d?prefilled_email=${email}`,
    },
    {
      plan_name: "Advanced",
      amt: "$39",
      img: <PlanImg3 className="plan-img" />,
      feature: ["400 AIO Keywords", "Daily Tracking"],
      plan_link: `https://buy.stripe.com/eVqbJ14wi2jW3LD2Jj0Fi1e?prefilled_email=${email}`,
    },
  ];

  return (
    <React.Fragment>
      {!isAIOTracker ? (
        <div className="pllogin-div">
          <div className={"add-new-project"}>
            <div className="project-img">
              <Player
                src={upgradeAnimation}
                className="player"
                loop
                autoplay
                speed={1}
              />
            </div>
            <div className="pl-con">
              <div>
                <h5>
                  <b>{t("pl_upgrade.title")}</b>
                </h5>
                <p className="mb-0">{t("pl_upgrade.description")}</p>
                <p>{t("pl_upgrade.select_plan")}</p>
                <button className="upgrade-plan-btn" onClick={gotologin}>
                  {t("pl_upgrade.button")}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="pllogin-div flex-column mt-3">
          <div>
            <h5
              className="my-3 mb-2"
              style={{ fontSize: "1.5rem", fontWeight: "600" }}
            >
              AI Overview Tracker
            </h5>
            <p className="mb-4" style={{ fontSize: "18px" }}>
              Monitor your website's visibility on Google AI overviews for top
              search queries with RanksPro.
            </p>
          </div>
          <section className="ai-plan-container">
            {plan?.map((item, index) => {
              return (
                <Paper
                  className="ai-tracker-card"
                  key={`${item.plan_name}-${item.amt}`}
                  elevation={3}
                >
                  <div className="d-flex flex-column align-items-start w-100">
                    <span className="plan-name w-100 flex justify-content-between">
                      {item.plan_name} <img src={AIOverviewIcon} />
                    </span>
                    {/* <span className="plan-sub-name">Starting at</span> */}
                  </div>
                  <div className="d-flex flex-column align-items-start w-100">
                    <span className="plan-dur">
                      <span className="plan-amt">{item.amt}</span> USD/month
                    </span>
                    {/* <span className="plan-amt-type">Monthly Subscription</span> */}
                  </div>

                  <a href={item.plan_link} target="_blank" className="w-100">
                    <button
                      style={{
                        width: "100%",
                        height: "50px",
                        borderRadius: "10px",
                        fontWeight: "500",
                      }}
                      className=""
                    >
                      Buy Now
                    </button>
                  </a>

                  <ul className="w-100">
                    {item.feature?.map((feature) => {
                      return (
                        <li key={feature}>
                          {/* <img src={ListStyleImg} alt="list" className="me-2" /> */}
                          <FiberManualRecordIcon
                            sx={{ width: 10, marginRight: "7px" }}
                          />
                          {feature}
                        </li>
                      );
                    })}
                  </ul>
                </Paper>
              );
            })}
          </section>
          <div style={{ width: "100%", padding: "0 50px" }}>
            <p className="mt-5" style={{ fontSize: "18px" }}>
              Utilize RanksPro's AI Overview tracker to monitor how your website
              and competitors are appearing on Google's AI-generated results.
              Track top-performing keywords appearing in snippets and AI-driven
              summaries to optimize your pages for increased visibility and
              traffic on AI overviews.
            </p>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default PlUpgrade;
